import { useEffect, useRef, useState } from "react";

import CreateExpenseTypeModal from "./create-expense-type";
import ExpensesModal from "./add-edit-expense";
import { Delete, Edit } from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import config from "../../config";
import moment from "moment";
import {
  Card,
  DatePicker,
  Image,
  Select,
  Button,
  Alert,
  Tabs,
  Modal,
} from "antd";
import ConfirmModal from "./confirm-modal";
import { useCurrency } from "../../provider/courtryProvider";
import CustomTable from "../table";
import dayjs from "dayjs";
import { EXPENSEACCESS } from "../../utils/constant";
import { useAccess } from "../../provider/AccessProvider";
const { RangePicker } = DatePicker;

const InvoicePreview = ({ open, onClose = () => {}, images = [] }) => {
  return (
    <div
      style={{
        display: "none",
      }}
    >
      <Image.PreviewGroup
        style={{
          display: "none",
        }}
        preview={{
          visible: open,
          scaleStep: 0.2,
          onVisibleChange: () => {
            onClose();
          },
        }}
      >
        {images.length > 0 ? (
          <>
            <div>
              {images.map((imgSrc) => {
                return <Image key={imgSrc.id} width={200} src={imgSrc.url} />;
              })}
            </div>
          </>
        ) : (
          <>No Images Found</>
        )}
      </Image.PreviewGroup>
    </div>
  );
};

const Expenses = () => {
  const [createExpenseType, setCreateExpenseType] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [deleteExpenseTypeModal, setDeleteExpenseTypeModal] = useState(false);
  const [expenseTypeToDelete, setExpenseTypeToDelete] = useState(null);
  const shopDetails = useSelector((state) => state.shopDetails);
  const [expensesList, setExpensesList] = useState([]);
  const [openPreview, setOpenPreview] = useState({
    visible: false,
    images: [],
  });
  const currencyFormatter = useCurrency();
  const [initialValue, setInitialValue] = useState({});
  const [loading, setLoading] = useState(true);
  const [mode, setMode] = useState("add");
  const [confirmModal, setConfirmModal] = useState();
  const [expenseId, setExpenseId] = useState();
  const access = useAccess(EXPENSEACCESS);
  const [selectedValue, setSelectedValue] = useState();
  const [activeTab, setActiveTab] = useState("history");
  const [date, setDate] = useState({
    startDate: dayjs().format("YYYY-MM-DD"),
    endDate: dayjs().format("YYYY-MM-DD"),
  });
  const rangeRef = useRef();
  const expenseTypeList =
    useSelector((state) => state.shopDetails.expensesType)?.filter(
      (i) => !i.deleted
    ) || [];
  const dispatch = useDispatch();

  const fetchExpenses = async () => {
    try {
      let res = await fetch(`${config.newApiGateway}/expenses/expenses`, {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          type: "fetch",
          shopId: shopDetails.shopId,
          from: date.startDate,
          to: date.endDate,
          employeeId: shopDetails.empId ? shopDetails.empId : "",
        }),
      });
      res = await res.json();

      if (res.code === "SUCCESS") {
        const result = res.data.map((i) => {
          const type = expenseTypeList.find(
            (item) => item.expensesTypeId === i.expenseType
          );
          return {
            ...i,
            expenseTypeName: type ? type.expensesTypeName : "",
          };
        });
        setExpensesList(result);
      }
    } catch (err) {
      console.error("Error", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = (rowData) => {
    setConfirmModal(true);
    setExpenseId(rowData.billId);
  };

  const handleEdit = (rowData) => {
    setInitialValue(rowData);
    setMode("edit");
    setOpenModal(true);
  };

  const handleDeleteExpenseType = (rowData) => {
    setExpenseTypeToDelete(rowData);
    setDeleteExpenseTypeModal(true);
  };

  const deleteExpenseType = async (expenseTypeId) => {
    try {
      const response = await fetch(
        `${config.newApiGateway}/expenses/addEditExpensesType`,
        {
          body: JSON.stringify({
            shopId: shopDetails.shopId,
            type: "delete",
            expensesTypeId: expenseTypeId,
            employeeId: shopDetails.empId ? shopDetails.empId : "",
            ...(["Employee", "Outlet"].includes(shopDetails.userType) && {
              parentShopId: shopDetails.ownerShopId,
            }),
          }),
          method: "POST",
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "content-type": "application/json",
          },
        }
      );
      const data = await response.json();
      if (data.code === "SUCCESS") {
        // Remove the expense type from Redux store
        const updatedExpenseTypes = expenseTypeList.filter(
          (type) => type.expensesTypeId !== expenseTypeId
        );
        dispatch({
          type: "EXPENSES_TYPE",
          payload: updatedExpenseTypes,
        });
        alert(data.message);
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error("Error deleting expense type:", err);
      alert("Error deleting expense type. Please try again.");
    }
  };

  useEffect(() => {
    if (shopDetails.shopId) {
      fetchExpenses();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopDetails.shopId, date]);

  const [customDate, setCustomDate] = useState([]);
  const handleChange = (value) => {
    setSelectedValue(value);
    const startDate = dayjs();
    const endDate = dayjs().format("YYYY-MM-DD");
    if (value === "today") {
      setDate({
        startDate: startDate.format("YYYY-MM-DD"),
        endDate: endDate,
      });
    } else if (value === "month") {
      setDate({
        startDate: dayjs().subtract(1, "month").format("YYYY-MM-DD"),
        endDate: dayjs().format("YYYY-MM-DD"),
      });
    } else if (value === "week") {
      setDate({
        startDate: dayjs().subtract(7, "days").format("YYYY-MM-DD"),
        endDate: dayjs().format("YYYY-MM-DD"),
      });
    }
  };

  const handleDateRange = (v) => {
    if (v === null) {
      setSelectedValue("today");
      setDate({
        startDate: dayjs().format("YYYY-MM-DD"),
        endDate: dayjs().format("YYYY-MM-DD"),
      });
      setCustomDate([]);
    } else {
      setCustomDate(v);
      const dateValue = v.map((i) => {
        return dayjs(i).format("YYYY-MM-DD");
      });
      setDate({
        startDate: dateValue[0],
        endDate: dateValue[1],
      });
    }
  };

  const expenseHistoryColumns = [
    {
      title: "Date",
      sorter: (a, b) =>
        moment(b.expenseDate, "YYYY-MM-DD").format("X") -
        moment(a.expenseDate, "YYYY-MM-DD").format("X"),
      render: (rowData) => {
        return (
          <span>
            {moment(rowData.expenseDate, "YYYY-MM-DD").format("DD-MM-YYYY")}
          </span>
        );
      },
      cellStyle: {
        textAlign: "center",
      },
      headerStyle: {
        textAlign: "center",
      },
    },
    {
      title: "Expense Amount",
      cellStyle: {
        textAlign: "center",
      },
      sorter: (a, b) => parseInt(b.expenseAmount) - parseInt(a.expenseAmount),
      headerStyle: {
        textAlign: "center",
      },
      render: (rowData) => {
        return <span>{currencyFormatter(rowData.expenseAmount)}</span>;
      },
    },
    {
      title: "Expense Type",
      cellStyle: {
        textAlign: "center",
        textTransform: "capitalize",
      },
      headerStyle: {
        textAlign: "center",
      },
      render: (rowData) => {
        const type = expenseTypeList.find(
          (i) => i.expensesTypeId === rowData.expenseType
        );

        return <span>{type?.expensesTypeName}</span>;
      },
    },
    {
      title: "Payment Method",
      render: (rowData) => {
        return <span>{rowData.paymentMethod}</span>;
      },

      cellStyle: {
        textAlign: "center",
        textTransform: "capitalize",
      },
      headerStyle: {
        textAlign: "center",
      },
    },
    {
      title: "Notes",
      render: (rowData) => {
        return <span>{rowData.notes}</span>;
      },

      cellStyle: {
        textAlign: "center",
        textTransform: "capitalize",
      },
      headerStyle: {
        textAlign: "center",
      },
    },
    {
      title: "Invoice Image",
      render: (rowData) => {
        return (
          <>
            {rowData.images?.length > 0 ? (
              <Button
                variant="link"
                onClick={() => {
                  setOpenPreview({
                    visible: true,
                    images: rowData.images,
                  });
                }}
              >
                Show
              </Button>
            ) : (
              <>-</>
            )}
          </>
        );
      },
      cellStyle: {
        textAlign: "center",
        textTransform: "capitalize",
      },
      headerStyle: {
        textAlign: "center",
      },
    },
    {
      title: "Action",
      render: (data) => {
        return (
          <div className="ViewDetailsBtn">
            <button
              style={{
                border: "none",
                background: "transparent",
              }}
              onClick={() => {
                if (!access.editExpense()) {
                  return;
                }
                handleEdit(data);
              }}
            >
              <Edit
                style={{
                  cursor: "pointer",
                }}
              />
            </button>
            <button
              style={{
                border: "none",
                background: "transparent",
              }}
              onClick={() => {
                if (!access.deleteExpense()) {
                  return;
                }
                handleDelete(data);
              }}
            >
              <Delete
                style={{
                  cursor: "pointer",
                }}
              />
            </button>
          </div>
        );
      },
      cellStyle: {
        textAlign: "center",
        textTransform: "capitalize",
      },
      headerStyle: {
        textAlign: "center",
      },
    },
  ];

  const expenseTypesColumns = [
    {
      title: "Expense Type Name",
      cellStyle: {
        textAlign: "center",
        textTransform: "capitalize",
      },
      headerStyle: {
        textAlign: "center",
      },
      render: (rowData) => {
        return <span>{rowData.expensesTypeName}</span>;
      },
    },
    {
      title: "Action",
      render: (data) => {
        return (
          <div className="ViewDetailsBtn">
            <button
              style={{
                border: "none",
                background: "transparent",
              }}
              onClick={() => {
                if (!access.createExpenseType()) {
                  return;
                }
                handleDeleteExpenseType(data);
              }}
            >
              <Delete
                style={{
                  cursor: "pointer",
                  color: "#ff4d4f",
                }}
              />
            </button>
          </div>
        );
      },
      cellStyle: {
        textAlign: "center",
        textTransform: "capitalize",
      },
      headerStyle: {
        textAlign: "center",
      },
    },
  ];

  const expenseHistoryExportHead = [
    "Date",
    "Expense Amount",
    "Type",
    "Payment Method",
    "Notes",
  ];
  const expenseHistoryExportValue = [
    "expenseDate",
    "expenseAmount",
    "expenseTypeName",
    "paymentMethod",
    "notes",
  ];

  const expenseTypesExportHead = ["Expense Type Name", "Created Date"];
  const expenseTypesExportValue = ["expensesTypeName", "createdAt"];

  if (!access.expense(false)) {
    return (
      <Alert
        style={{
          padding: "20px",
          textAlign: "center",
        }}
        message="You don't have access, Please contact your administrator to request the appropriate access."
        type="error"
      />
    );
  }

  return (
    <>
      <div>
        <Card
          style={{
            marginBottom: 20,
          }}
          bodyStyle={{
            display: "flex",
          }}
        >
          {selectedValue !== "custom" && (
            <Select
              value={selectedValue}
              onChange={handleChange}
              defaultValue="today"
              style={{
                width: "200px",
              }}
            >
              <Select.Option value="today">Today</Select.Option>
              <Select.Option value="week">Last 7 days</Select.Option>
              <Select.Option value="month">Last 30 days</Select.Option>
              <Select.Option value="custom">Custom Date</Select.Option>
            </Select>
          )}
          {selectedValue === "custom" && (
            <RangePicker
              ref={rangeRef}
              value={customDate}
              onChange={handleDateRange}
              open={customDate?.length === 2 ? false : true}
            />
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              gap: 8,
              marginLeft: "auto",
            }}
          >
            {/* <Button
              type="primary"
              onClick={() => {
                if (!access.createExpense()) {
                  return;
                }
                setOpenModal(true);
                setMode("add");
              }}
              ghost
            >
              Create Expense
            </Button> */}
            <Button
              type="primary"
              ghost
              onClick={() => {
                if (!access.createExpenseType()) {
                  return;
                }
                setCreateExpenseType(true);
              }}
            >
              Create Expense Type
            </Button>
          </div>
        </Card>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={[
            {
              key: "history",
              label: "Expense History",
              children: (
                <CustomTable
                  title={"Expenses History"}
                  data={expensesList}
                  excelExport={true}
                  exportHead={expenseHistoryExportHead}
                  exportValue={expenseHistoryExportValue}
                  columns={expenseHistoryColumns}
                  loading={loading}
                  emptyContainerStyle={{
                    height: "calc(100vh - 300px)",
                  }}
                  csvAccessKey="expenseCSVExport"
                />
              ),
            },
            {
              key: "types",
              label: "Expense Types",
              children: (
                <CustomTable
                  title={"Expense Types"}
                  data={expenseTypeList || []}
                  excelExport={true}
                  exportHead={expenseTypesExportHead}
                  exportValue={expenseTypesExportValue}
                  columns={expenseTypesColumns}
                  loading={false}
                  emptyContainerStyle={{
                    height: "calc(100vh - 300px)",
                  }}
                  csvAccessKey="expenseTypesCSVExport"
                />
              ),
            },
          ]}
        />
        {/* <div className="reports-container">
          <div
            id="date-picker"
            style={{ margin: "20px", position: "relative" }}
          >
            {selectedValue !== "custom" && (
              <Select
                value={selectedValue}
                onChange={handleChange}
                defaultValue="today"
                style={{
                  width: "200px",
                }}
              >
                <Select.Option value="today">Today</Select.Option>
                <Select.Option value="week">Last 7 days</Select.Option>
                <Select.Option value="month">Last 30 days</Select.Option>
                <Select.Option value="custom">Custom Date</Select.Option>
              </Select>
            )}
            {selectedValue === "custom" && (
              <RangePicker
                ref={rangeRef}
                value={customDate}
                onChange={handleDateRange}
                open={customDate?.length === 2 ? false : true}
              />
            )}

            <div style={{ textAlign: "right", marginBottom: "20px" }}>
              <Button
                variant="outline-danger"
                style={{
                  marginLeft: "20px",
                  cursor: "pointer",
                  background: "#ef4667",
                  color: "#fff",
                }}
                onClick={() => {
                  setTab("history");
                }}
              >
                History
              </Button>
              <Button
                variant="outline-danger"
                style={{
                  marginLeft: "20px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setOpenModal(true);
                  setMode("add");
                }}
              >
                Add Expenses
              </Button>
              <Button
                variant="outline-danger"
                style={{
                  marginLeft: "20px",
                  cursor: "pointer",
                }}
                onClick={() => setCreateExpenseType(true)}
              >
                Create Expenses Type
              </Button>
            </div>
          </div>
        </div> */}
        {/* {tab === "history" && (
          <MaterialTable
            style={{ margin: "20px", textAlign: "center" }}
            isLoading={loading}
            columns={[
              {
                title: "Date",
                render: (rowData) => {
                  return (
                    <span>
                      {moment(rowData.expenseDate, "YYYY-MM-DD").format(
                        "DD-MM-YYYY"
                      )}
                    </span>
                  );
                },
                cellStyle: {
                  textAlign: "center",
                },
                headerStyle: {
                  textAlign: "center",
                },
              },
              {
                title: "Expense Amount",
                cellStyle: {
                  textAlign: "center",
                },
                headerStyle: {
                  textAlign: "center",
                },
                render: (rowData) => {
                  return (
                    <span>{currencyFormatter(rowData.expenseAmount)}</span>
                  );
                },
              },
              {
                title: "Expense Type",
                cellStyle: {
                  textAlign: "center",
                  textTransform: "capitalize",
                },
                headerStyle: {
                  textAlign: "center",
                },
                render: (rowData) => {
                  const type = expenseTypeList.find(
                    (i) => i.expensesTypeId === rowData.expenseType
                  );

                  return <span>{type?.expensesTypeName}</span>;
                },
              },
              {
                title: "Payment Method",
                render: (rowData) => {
                  return <span>{rowData.paymentMethod}</span>;
                },

                cellStyle: {
                  textAlign: "center",
                  textTransform: "capitalize",
                },
                headerStyle: {
                  textAlign: "center",
                },
              },
              {
                title: "Invoice Image",
                render: (rowData) => {
                  return (
                    <>
                      {rowData.images?.length > 0 ? (
                        <Button
                          variant="link"
                          onClick={() => {
                            setOpenPreview({
                              visible: true,
                              images: rowData.images,
                            });
                          }}
                        >
                          Show
                        </Button>
                      ) : (
                        <>-</>
                      )}
                    </>
                  );
                },
                cellStyle: {
                  textAlign: "center",
                  textTransform: "capitalize",
                },
                headerStyle: {
                  textAlign: "center",
                },
              },
              {
                title: "Action",
                render: (data) => {
                  return (
                    <div className="ViewDetailsBtn">
                      <button
                        style={{
                          border: "none",
                          background: "transparent",
                        }}
                        onClick={() => handleEdit(data)}
                      >
                        <Edit
                          style={{
                            cursor: "pointer",
                          }}
                        />
                      </button>
                      <button
                        style={{
                          border: "none",
                          background: "transparent",
                        }}
                        onClick={() => handleDelete(data)}
                      >
                        <Delete
                          style={{
                            cursor: "pointer",
                          }}
                        />
                      </button>
                    </div>
                  );
                },
                cellStyle: {
                  textAlign: "center",
                  textTransform: "capitalize",
                },
                headerStyle: {
                  textAlign: "center",
                },
              },
            ]}
            icons={tableIcons}
            data={expensesList}
            title={<></>}
            components={{
              Pagination: PatchedPagination,
            }}
            options={{
              search: true,
              exportButton: {
                csv: true,
              },
              exportCsv: (_columns, renderData) => {
                const fields = [
                  "Date",
                  "Expense Amount",
                  "Expense Type",
                  "Payment Method",
                ];
                const opts = { fields };
                const parser = new Parser(opts);
                const rows = expensesList.map((i) => {
                  const type = expenseTypeList.find(
                    (item) => item.expensesTypeId === i.expenseType
                  );
                  return {
                    Date: i.expenseDate,
                    "Expense Amount": i.expenseAmount,
                    "Expense Type": type.expensesTypeName,
                    "Payment Method": i.paymentMethod,
                  };
                });

                const csv = parser.parse(rows);

                var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
                var link = document.createElement("a");

                var url = URL.createObjectURL(blob);

                link.setAttribute("href", url);
                link.setAttribute("download", "Expenses.csv");
                link.style.visibility = "hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              },

              // exportCsv: (columns, data) => {
              //   console.log("columns12", columns, data);
              // },
              exportFileName: "Expenses",
              exportAllData: true,
              columnsButton: true,
              pageSize: 10,
            }}
          />
        )} */}
      </div>

      <InvoicePreview
        open={openPreview.visible}
        onClose={() => setOpenPreview({ visible: false, images: [] })}
        images={openPreview.images}
      />
      <CreateExpenseTypeModal
        open={createExpenseType}
        setOpen={setCreateExpenseType}
      />
      <ExpensesModal
        open={openModal}
        mode={mode}
        initialValues={initialValue}
        setOpen={setOpenModal}
        fetchExpenses={fetchExpenses}
      />
      <ConfirmModal
        open={confirmModal}
        expenseId={expenseId}
        setOpen={() => setConfirmModal(false)}
        fetchExpenses={fetchExpenses}
      />

      {/* Delete Expense Type Modal */}
      <Modal
        title="Delete Expense Type"
        open={deleteExpenseTypeModal}
        onCancel={() => {
          setDeleteExpenseTypeModal(false);
          setExpenseTypeToDelete(null);
        }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setDeleteExpenseTypeModal(false);
              setExpenseTypeToDelete(null);
            }}
          >
            Cancel
          </Button>,
          <Button
            key="delete"
            type="primary"
            danger
            onClick={() => {
              if (expenseTypeToDelete) {
                deleteExpenseType(expenseTypeToDelete.expensesTypeId);
                setDeleteExpenseTypeModal(false);
                setExpenseTypeToDelete(null);
              }
            }}
          >
            Delete
          </Button>,
        ]}
      >
        <div style={{ marginTop: 16 }}>
          <p>
            Are you sure you want to delete the expense type "
            {expenseTypeToDelete?.expensesTypeName}"? This action cannot be
            undone.
          </p>
        </div>
      </Modal>
    </>
  );
};
export default Expenses;
